import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { PlayService } from '../../../play/play.service';
import { HomeComponent } from '../../home.component';
import { ActivatedRoute, Router } from '@angular/router';
import { WpService } from 'src/app/services/wp.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'home-mobile',
  templateUrl: './home-mobile.component.html',
  styleUrls: ['./home-mobile.component.scss', '../../../../app.component.scss']
})

export class HomeMobileComponent extends HomeComponent {
  @Input()
  public isBeginEnabled: boolean = false;

  constructor(
    playIntroService: PlayService,
    router: Router,
    route: ActivatedRoute,
    wpService: WpService,
    userService: UserService,
  ) {
    super(playIntroService, router, route, wpService, userService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  public nicknameSubmit($event){
    $event.preventDefault();
  }
}

